import {ReactNode} from 'react';
import {Accordion, useAccordionButton} from 'react-bootstrap';

function CustomToggle({
  children,
  eventKey,
}: {
  children: ReactNode;
  eventKey: string;
}) {
  const decoratedOnClick = useAccordionButton(eventKey);

  return <div onClick={decoratedOnClick}>{children}</div>;
}

type TFaqItemProps = {
  faq: IFaq;
  index: string;
  activeKey?: string;
};

const FaqItem = ({faq, index, activeKey}: TFaqItemProps) => {
  return (
    <>
      <div className="border-bottom py-3">
        <div>
          <CustomToggle eventKey={index}>
            <div className="d-flex justify-content-between align-items-center color-gray-1">
              <small>{faq.title}</small>
              <i
                className={
                  activeKey === index ? 'icon-arrow-up' : 'icon-arrow-down'
                }
              ></i>
            </div>
          </CustomToggle>
        </div>
        <Accordion.Collapse eventKey={index}>
          <div className="py-2">
            <small className="color-primary">{faq.description}</small>
          </div>
        </Accordion.Collapse>
      </div>
    </>
  );
};

export default FaqItem;
